import React from 'react'

import { Page } from '../../../common/components/sections'
import { APP_ROUTES } from '../../../common/constants'
import { useDocumentTitle } from '../../../common/hooks'

import { BrandCurationTasksFilters, BrandCurationTasksTable } from '../sections'

const BrandCurationTasksPage = () => {
  useDocumentTitle(APP_ROUTES.BRANDS.label)

  return (
    <Page>
      <BrandCurationTasksFilters />
      <BrandCurationTasksTable />
    </Page>
  )
}

export default BrandCurationTasksPage
